/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespIconBubblesWrapper_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_viewer" | "PdpRespTradeIconBubbles_viewer">;
    readonly " $refType": "PdpRespIconBubblesWrapper_viewer";
};
export type PdpRespIconBubblesWrapper_viewer$data = PdpRespIconBubblesWrapper_viewer;
export type PdpRespIconBubblesWrapper_viewer$key = {
    readonly " $data"?: PdpRespIconBubblesWrapper_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubblesWrapper_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_viewer"
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '50d384ae4d7efb2d8117904c0184cfaf';
export default node;
